import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/common/more-icon-1.png';

const _withScopeId = n => (_pushScopeId("data-v-2f507237"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "course-wrapper"
};
const _hoisted_2 = {
  class: "course_header"
};
const _hoisted_3 = {
  class: "course-content"
};
const _hoisted_4 = {
  class: "course-data"
};
const _hoisted_5 = {
  class: "more"
};
const _hoisted_6 = ["href"];

const _hoisted_7 = /*#__PURE__*/_createTextVNode("更多 ");

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "icon"
}, null, -1));

const _hoisted_9 = [_hoisted_7, _hoisted_8];
const _hoisted_10 = {
  class: "course-list"
};
const _hoisted_11 = {
  class: "course-card-list"
};
const _hoisted_12 = {
  key: 1,
  class: "no-data"
};
const _hoisted_13 = {
  class: "user-box"
};
const _hoisted_14 = {
  class: "new-img"
};
const _hoisted_15 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CourseCard = _resolveComponent("CourseCard");

  const _component_Empty = _resolveComponent("Empty");

  const _component_UserCard = _resolveComponent("UserCard");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString($props.menu.module_name), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("a", {
    href: `/courseList.html?type=1&name=${$props.menu.module_name}&menuId=${$props.menu.menu_id}`
  }, _hoisted_9, 8, _hoisted_6)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [$data.homeCourseList && $data.homeCourseList.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($data.homeCourseList.slice(0, 3), course => {
    return _openBlock(), _createBlock(_component_CourseCard, {
      class: "home-course-card",
      "course-data": course,
      key: course.id,
      "show-label": true,
      userInfo: $props.userInfo,
      authType: $data.authType
    }, null, 8, ["course-data", "userInfo", "authType"]);
  }), 128)) : (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_Empty)]))])])]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_UserCard, {
    userInfo: $props.userInfo,
    zhsRole: $props.zhsRole
  }, null, 8, ["userInfo", "zhsRole"])])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("img", {
    src: require('@/assets/images/maskgroup2.png'),
    alt: "",
    class: "img"
  }, null, 8, _hoisted_15)])]);
}